export default __webpack_public_path__ + "static/media/logoP.c1d13b20.png";